const amountFormatter = new Intl.NumberFormat('en-PH', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const capturedAtFormatter = new Intl.DateTimeFormat('en-PH', {
  month: 'short',
  day: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export function formatReceiptCapturedAt(value: string) {
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '—';
  return capturedAtFormatter.format(parsed);
}

export function formatReceiptAmount(value: string | null) {
  if (!value) return '—';
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return '—';
  return `₱${amountFormatter.format(parsed / 100)}`;
}
